module.exports = __webpack_public_path__ + "img/match-logo-6.0cf45186.png";